import React, { createContext, useContext, useEffect, useState } from 'react';
import { translations } from '../i18n/translations';

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('aurra_lang') || 'fr');
  const [theme, setTheme] = useState(() => localStorage.getItem('aurra_theme') || 'light');

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') root.classList.add('dark');
    else root.classList.remove('dark');
    localStorage.setItem('aurra_theme', theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem('aurra_lang', lang);
  }, [lang]);

  const toggleTheme = () => setTheme((t) => (t === 'dark' ? 'light' : 'dark'));
  const toggleLang = () => setLang((l) => (l === 'fr' ? 'en' : 'fr'));
  const t = translations[lang];

  return (
    <AppContext.Provider value={{ lang, setLang, toggleLang, theme, setTheme, toggleTheme, t }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useApp must be used within AppProvider');
  return ctx;
};
